import { render, staticRenderFns } from "./list-history-visits.view.vue?vue&type=template&id=691bebd8&"
import script from "./list-history-visits.view.vue?vue&type=script&lang=js&"
export * from "./list-history-visits.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports